// extracted by mini-css-extract-plugin
export default {"card__img":"image_card__img__aB1PW","main":"image_main__pupYO","detail":"image_detail__w+9x6"};